





































































































































import { SharedState } from "@/common/state";
import AppToggleBtn from "@/components/AppToggleBtn.vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { UseModal } from "@/components/root/modal";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { computed, onMounted } from "@vue/composition-api";
import Vue from "vue";
import NotificationEmailModalVue from "../notification-email/NotificationEmailModal.vue";
import { MassDownloadPolicyL0StatusItem } from "./data/model";
import { state } from "./data/state";
import NotificationTemplateModalVue from "./NotificationTemplateModal.vue";
import MassDownlodersModal from "./users-modal/MassDownlodersModal.vue";
export default Vue.extend({
  props: ["has_feature"],
  components: { AppToggleBtn, DropDownSimple, SkeletonLoaderItem },
  setup() {
    const policy_options = [
      { name: "Inactive", id: -1 },
      ...[10, 20, 50, 100].map((id) => ({ id, name: `${id} Downloads` })),
    ];

    const { status_list, is_loading, toggle_item_activity_state } = state;
    onMounted(async () => {
      SharedState.onReady(async () => {
        await state.init();
      });
    });
    const show_risky_users = async (item: MassDownloadPolicyL0StatusItem) => {
      console.log("item.id: ", item.id);
      await UseModal().show(MassDownlodersModal, {
        id: item.id,
        name: item.name,
      });
    };

    const show_email_template = async (
      item: MassDownloadPolicyL0StatusItem
    ) => {
      await UseModal().show(NotificationEmailModalVue, {
        title: item.name,
        feature_id: "download_policy",
        info_type: item.id,
      });
    };

    /*  const show_email_template = async (
      item: MassDownloadPolicyL0StatusItem
    ) => {
      await UseModal().show(NotificationTemplateModalVue, {
        name: item.name,
      });
    }; */

    const change_detected_level = async (
      item: MassDownloadPolicyL0StatusItem,
      level: number
    ) => {
      await state.update_policy_level(item.id, level);
    };

    return {
      status_list,
      toggle_item_activity_state,
      show_risky_users,
      show_email_template,
      is_loading,
      policy_options,
      change_detected_level,
    };
  },
});
